import { createReducer, on } from '@ngrx/store';
import * as ProductActions from './community-product.action';
import { CommunityProduct } from '../../models/community-product.model';
import { ErrorPayload } from './community-product.state';

// Error payload structure for type safety

// State interface
export interface ProductState {
  communityProducts: CommunityProduct[];
  loading: boolean;
  error: ErrorPayload | null;
}

// Initial state
export const initialState: ProductState = {
  communityProducts: [],
  loading: false,
  error: null,
};

// Reducer for community products
export const communityProductReducer = createReducer(
  initialState,

  // When loading all products
  on(ProductActions.loadAllCommunityProducts, (state) => ({
    ...state,
    loading: true,
    error: null, // Reset error on new load
  })),

  // When loading all products succeeds
  on(ProductActions.loadAllCommunityProductsSuccess, (state, { communityProducts }) => ({
    ...state,
    communityProducts: communityProducts || [], // Fallback to empty array
    loading: false,
  })),

  // When loading all products fails
  on(ProductActions.loadAllCommunityProductsFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  
);
